<template lang="pug">
	.sfc-simple-button(:id="id" :class="{'loading': loading, 'blue': blue, 'white': white, 'orange': orange, 'disabled': disabled, 'medium-size': mediumSize, 'square': square}" @click="emitClick($event)" role="button" tabindex="0" @keyup.prevent="handleKeyPress")
		.content(v-if="!loading")
			.button-text(v-if="!link") {{text}}
			a.button-text(ref="sfcButtonLink" v-if="link && nofollow" :href="href" :target="target" tabindex="-1" rel="nofollow")
				| {{text}}
				span.sr-only(v-if="srOnlyContent")
					| {{srOnlyContent}}
			a.button-text(ref="sfcButtonLink" v-if="link && !nofollow" :href="href" :target="target" tabindex="-1")
				| {{text}}
				span.sr-only(v-if="srOnlyContent")
					| {{srOnlyContent}}
		spinner.spinner(size="20" v-if="loading")
</template>

<style lang="stylus" scoped>
	@import '~assets/css/redesign-v1/variables.styl'

.spinner
	display: inline-block
	margin: auto
	line-height: normal

.sfc-simple-button
	position: relative
	display: flex
	cursor: pointer
	text-align: center
	font-size: body-font-size - 2
	font-weight: body-font-weight-strong
	border-radius(25px)
	max-height 50px
	min-width: 150px
	@media (max-width: 575px)
		max-height: none
	.content
		width: 100%
		margin: auto
		line-height: normal
		text-transform: uppercase
	a
	.button-text
	.spinner
		display: inline-block
		width: 100%
		height: 100%
		padding: 13px 20px
	a
		text-decoration: none
		&:hover
			text-decoration: none
	&.white
		background: #fff
		color: blue-primary
		a
			color: blue-primary !important
		&:hover
			color: blue-hover
	&.blue
		background: blue-primary
		color: #fff
		a
			color: #fff !important
		&:hover
			background: blue-hover
	&.orange
		background: orange-secondary
		color: #fff
		a
			color: #fff !important
		&:hover
			background: orange-hover
	&.disabled
		background: blue-disabled
		color: #fff
		a
			color: #fff !important
		&:hover
			color: #fff !important
			background: blue-disabled
	&.square
		border-radius(4px)
		.button-text
			padding: 12px 20px
	&.medium-size
		max-height: 44px
		font-size: body-font-size-md
		a
		.button-text
		.spinner
			padding: 11px 20px 12px
</style>

<script>
import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'

export default {
	components: {
		Spinner
	},
	props: {
		id: {
			default: undefined
		},
		text:{
			default: "Start"
		},
		loading:{
			default: false
		},
		white:{
			default: false
		},
		blue:{
			default: false
		},
		orange:{
			default: false
		},
		disabled: {
			default: false
		},
		mediumSize:{
			default: false
		},
		square:{
			default: false
		},
		link: {
			default: false
		},
		href: {
			default: ""
		},
		target: {
			default: "_self"
		},
		srOnlyContent: {
			// screen reader only content
			default: undefined
		},
		nofollow: {
			default: false
		},
	},

	methods:{
		emitClick(event){
			if(!this.disabled){
				this.$emit('click', event)
			}
		}
	}
}
</script>
